//import facebook from '@/lego/boot/facebook';
import google from '@/lego/boot/google';
import hotjar from '@/lego/boot/hotjar';
import linkedin from '@/lego/boot/linkedin';
//import zoho from '@/lego/boot/zoho';

export default function boot(app) {
  //facebook(app);
  google(app);
  hotjar(app);
  linkedin(app);
  //zoho(app);
}
